import { isDarel } from "~/lib/brand"

export * from "./cookies"
export * from "./query-keys"
export * from "./revalidate-tags"

export const HOST_NAME = isDarel ? "gerarddarel.com" : "pablo.fr"
